export default __webpack_public_path__ + "static/bronze_tier-e9c178460d992494438edd0b05e4b15f.png";